export default "__VITE_ASSET__BRc$uOtq__"